import React from 'react'
import { Copy04Icon } from 'src/editor/shared/icons/copy-04-icon'

export interface InputCopyProps {
  onCopy: () => void
}

export const InputCopy = ({ onCopy }: InputCopyProps) => {
  return (
    <Copy04Icon
      className="cursor-pointer hover:fill-iconPrimary"
      onClick={onCopy}
    />
  )
}
